// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"d54e9a5f","322":"366dab80","414":"4111de85","534":"32aa21dd","614":"98889393"}[chunkId] + ".chunk.js";
};